import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesSupportStaffMain } from './modules/ui/Main';

const SupportStaffPage = (
  <SuspensePage>
    <PagesSupportStaffMain />
  </SuspensePage>
);

export default SupportStaffPage;
